// Complete ISO 3166-1 alpha-2 country list — used by any UI that needs
// to show ALL countries (birth country selector, address country
// picker, etc.). Separate from COUNTRY_PREFIXES which only exposes the
// 35 countries LoJack supports for phone dial-in prefixes.
//
// Fabrizio bug 24/07/2026 (Bohdan Slutinsky test): the previous
// birth-country dropdown reused COUNTRY_PREFIXES (35 countries only)
// which excluded ~150 countries including Bielorussia, Ucraina, and
// most of Africa/Asia. This full 193-country list ships with the
// library's ANPR data.
//
// SOURCE OF TRUTH: auto-generated from python-codicefiscale's ANPR
// dataset by backend/scripts/regen_country_data.py. Do NOT hand-edit —
// regen after each library upgrade.
//
// name_it is the fallback Italian display name — production UI uses
// Intl.DisplayNames via getLocalizedCountryName() for full multi-lingual
// support (IT/EN/FR/DE/ES/NL/PT/PL/etc).

// Compact ISO alpha-2 → flag emoji helper (regional indicator points).
export const isoToFlag = (iso) => {
  if (!iso || iso.length !== 2) return "";
  return iso
    .toUpperCase()
    .split("")
    .map((c) => String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65))
    .join("");
};

export const ALL_ISO_COUNTRIES = [
  { code: "AD", name_it: "Andorra", flag: "🇦🇩" },
  { code: "AE", name_it: "Emirati Arabi Uniti", flag: "🇦🇪" },
  { code: "AF", name_it: "Afghanistan", flag: "🇦🇫" },
  { code: "AG", name_it: "Antigua e Barbuda", flag: "🇦🇬" },
  { code: "AL", name_it: "Albania", flag: "🇦🇱" },
  { code: "AM", name_it: "Armenia", flag: "🇦🇲" },
  { code: "AO", name_it: "Angola", flag: "🇦🇴" },
  { code: "AR", name_it: "Argentina", flag: "🇦🇷" },
  { code: "AT", name_it: "Austria", flag: "🇦🇹" },
  { code: "AU", name_it: "Australia", flag: "🇦🇺" },
  { code: "AZ", name_it: "Azerbaigian", flag: "🇦🇿" },
  { code: "BA", name_it: "Bosnia-Erzegovina", flag: "🇧🇦" },
  { code: "BB", name_it: "Barbados", flag: "🇧🇧" },
  { code: "BD", name_it: "Bangladesh", flag: "🇧🇩" },
  { code: "BE", name_it: "Belgio", flag: "🇧🇪" },
  { code: "BF", name_it: "Burkina Faso", flag: "🇧🇫" },
  { code: "BG", name_it: "Bulgaria", flag: "🇧🇬" },
  { code: "BH", name_it: "Bahrein", flag: "🇧🇭" },
  { code: "BI", name_it: "Burundi", flag: "🇧🇮" },
  { code: "BJ", name_it: "Benin", flag: "🇧🇯" },
  { code: "BN", name_it: "Brunei", flag: "🇧🇳" },
  { code: "BO", name_it: "Bolivia", flag: "🇧🇴" },
  { code: "BR", name_it: "Brasile", flag: "🇧🇷" },
  { code: "BS", name_it: "Bahamas", flag: "🇧🇸" },
  { code: "BT", name_it: "Bhutan", flag: "🇧🇹" },
  { code: "BW", name_it: "Botswana", flag: "🇧🇼" },
  { code: "BY", name_it: "Bielorussia", flag: "🇧🇾" },
  { code: "BZ", name_it: "Belize", flag: "🇧🇿" },
  { code: "CA", name_it: "Canada", flag: "🇨🇦" },
  { code: "CD", name_it: "Congo", flag: "🇨🇩" },
  { code: "CF", name_it: "Repubblica Centrafricana", flag: "🇨🇫" },
  { code: "CG", name_it: "Congo", flag: "🇨🇬" },
  { code: "CH", name_it: "Svizzera", flag: "🇨🇭" },
  { code: "CI", name_it: "Costa d'Avorio", flag: "🇨🇮" },
  { code: "CL", name_it: "Cile", flag: "🇨🇱" },
  { code: "CM", name_it: "Camerun", flag: "🇨🇲" },
  { code: "CN", name_it: "Repubblica Popolare Cinese", flag: "🇨🇳" },
  { code: "CO", name_it: "Colombia", flag: "🇨🇴" },
  { code: "CR", name_it: "Costa Rica", flag: "🇨🇷" },
  { code: "CU", name_it: "Cuba", flag: "🇨🇺" },
  { code: "CV", name_it: "Capo Verde", flag: "🇨🇻" },
  { code: "CY", name_it: "Cipro", flag: "🇨🇾" },
  { code: "CZ", name_it: "Repubblica Ceca", flag: "🇨🇿" },
  { code: "DE", name_it: "Germania", flag: "🇩🇪" },
  { code: "DJ", name_it: "Gibuti", flag: "🇩🇯" },
  { code: "DK", name_it: "Danimarca", flag: "🇩🇰" },
  { code: "DM", name_it: "Dominica", flag: "🇩🇲" },
  { code: "DO", name_it: "Repubblica Dominicana", flag: "🇩🇴" },
  { code: "DZ", name_it: "Algeria", flag: "🇩🇿" },
  { code: "EC", name_it: "Ecuador", flag: "🇪🇨" },
  { code: "EE", name_it: "Estonia", flag: "🇪🇪" },
  { code: "EG", name_it: "Egitto", flag: "🇪🇬" },
  { code: "ER", name_it: "Eritrea", flag: "🇪🇷" },
  { code: "ES", name_it: "Spagna", flag: "🇪🇸" },
  { code: "ET", name_it: "Etiopia", flag: "🇪🇹" },
  { code: "FI", name_it: "Finlandia", flag: "🇫🇮" },
  { code: "FJ", name_it: "Figi", flag: "🇫🇯" },
  { code: "FM", name_it: "Stati Federati Di Micronesia", flag: "🇫🇲" },
  { code: "FR", name_it: "Francia", flag: "🇫🇷" },
  { code: "GA", name_it: "Gabon", flag: "🇬🇦" },
  { code: "GB", name_it: "Regno Unito", flag: "🇬🇧" },
  { code: "GD", name_it: "Grenada", flag: "🇬🇩" },
  { code: "GE", name_it: "Georgia", flag: "🇬🇪" },
  { code: "GH", name_it: "Ghana", flag: "🇬🇭" },
  { code: "GM", name_it: "Gambia", flag: "🇬🇲" },
  { code: "GN", name_it: "Guinea", flag: "🇬🇳" },
  { code: "GQ", name_it: "Guinea Equatoriale", flag: "🇬🇶" },
  { code: "GR", name_it: "Grecia", flag: "🇬🇷" },
  { code: "GT", name_it: "Guatemala", flag: "🇬🇹" },
  { code: "GW", name_it: "Guinea Bissau", flag: "🇬🇼" },
  { code: "GY", name_it: "Guyana", flag: "🇬🇾" },
  { code: "HN", name_it: "Honduras", flag: "🇭🇳" },
  { code: "HR", name_it: "Croazia", flag: "🇭🇷" },
  { code: "HT", name_it: "Haiti", flag: "🇭🇹" },
  { code: "HU", name_it: "Ungheria", flag: "🇭🇺" },
  { code: "ID", name_it: "Indonesia", flag: "🇮🇩" },
  { code: "IE", name_it: "Irlanda", flag: "🇮🇪" },
  { code: "IL", name_it: "Israele", flag: "🇮🇱" },
  { code: "IN", name_it: "India", flag: "🇮🇳" },
  { code: "IQ", name_it: "Iraq", flag: "🇮🇶" },
  { code: "IR", name_it: "Iran", flag: "🇮🇷" },
  { code: "IS", name_it: "Islanda", flag: "🇮🇸" },
  { code: "IT", name_it: "Italia", flag: "🇮🇹" },
  { code: "JM", name_it: "Giamaica", flag: "🇯🇲" },
  { code: "JO", name_it: "Giordania", flag: "🇯🇴" },
  { code: "JP", name_it: "Giappone", flag: "🇯🇵" },
  { code: "KE", name_it: "Kenya", flag: "🇰🇪" },
  { code: "KG", name_it: "Kirghizistan", flag: "🇰🇬" },
  { code: "KH", name_it: "Cambogia", flag: "🇰🇭" },
  { code: "KI", name_it: "Kiribati", flag: "🇰🇮" },
  { code: "KM", name_it: "Comore", flag: "🇰🇲" },
  { code: "KN", name_it: "Saint Kitts e Nevis", flag: "🇰🇳" },
  { code: "KP", name_it: "Repubblica Popolare Democratica Di Corea", flag: "🇰🇵" },
  { code: "KR", name_it: "Repubblica Di Corea", flag: "🇰🇷" },
  { code: "KW", name_it: "Kuwait", flag: "🇰🇼" },
  { code: "KZ", name_it: "Kazakhstan", flag: "🇰🇿" },
  { code: "LA", name_it: "Laos", flag: "🇱🇦" },
  { code: "LB", name_it: "Libano", flag: "🇱🇧" },
  { code: "LC", name_it: "Saint Lucia", flag: "🇱🇨" },
  { code: "LI", name_it: "Liechtenstein", flag: "🇱🇮" },
  { code: "LK", name_it: "Sri Lanka", flag: "🇱🇰" },
  { code: "LR", name_it: "Liberia", flag: "🇱🇷" },
  { code: "LS", name_it: "Lesotho", flag: "🇱🇸" },
  { code: "LT", name_it: "Lituania", flag: "🇱🇹" },
  { code: "LU", name_it: "Lussemburgo", flag: "🇱🇺" },
  { code: "LV", name_it: "Lettonia", flag: "🇱🇻" },
  { code: "LY", name_it: "Libia", flag: "🇱🇾" },
  { code: "MA", name_it: "Marocco", flag: "🇲🇦" },
  { code: "MC", name_it: "Monaco", flag: "🇲🇨" },
  { code: "MD", name_it: "Moldova", flag: "🇲🇩" },
  { code: "ME", name_it: "Montenegro", flag: "🇲🇪" },
  { code: "MG", name_it: "Madagascar", flag: "🇲🇬" },
  { code: "MH", name_it: "Isole Marshall", flag: "🇲🇭" },
  { code: "MK", name_it: "Macedonia Del Nord", flag: "🇲🇰" },
  { code: "ML", name_it: "Mali", flag: "🇲🇱" },
  { code: "MM", name_it: "Myanmar", flag: "🇲🇲" },
  { code: "MN", name_it: "Mongolia", flag: "🇲🇳" },
  { code: "MR", name_it: "Mauritania", flag: "🇲🇷" },
  { code: "MT", name_it: "Malta", flag: "🇲🇹" },
  { code: "MU", name_it: "Mauritius", flag: "🇲🇺" },
  { code: "MV", name_it: "Maldive", flag: "🇲🇻" },
  { code: "MW", name_it: "Malawi", flag: "🇲🇼" },
  { code: "MX", name_it: "Messico", flag: "🇲🇽" },
  { code: "MY", name_it: "Malaysia", flag: "🇲🇾" },
  { code: "MZ", name_it: "Mozambico", flag: "🇲🇿" },
  { code: "NA", name_it: "Namibia", flag: "🇳🇦" },
  { code: "NE", name_it: "Niger", flag: "🇳🇪" },
  { code: "NG", name_it: "Nigeria", flag: "🇳🇬" },
  { code: "NI", name_it: "Nicaragua", flag: "🇳🇮" },
  { code: "NL", name_it: "Paesi Bassi", flag: "🇳🇱" },
  { code: "NO", name_it: "Norvegia", flag: "🇳🇴" },
  { code: "NP", name_it: "Nepal", flag: "🇳🇵" },
  { code: "NR", name_it: "Nauru", flag: "🇳🇷" },
  { code: "NZ", name_it: "Nuova Zelanda", flag: "🇳🇿" },
  { code: "OM", name_it: "Oman", flag: "🇴🇲" },
  { code: "PA", name_it: "Panama", flag: "🇵🇦" },
  { code: "PE", name_it: "Peru'", flag: "🇵🇪" },
  { code: "PG", name_it: "Papua Nuova Guinea", flag: "🇵🇬" },
  { code: "PH", name_it: "Filippine", flag: "🇵🇭" },
  { code: "PK", name_it: "Pakistan", flag: "🇵🇰" },
  { code: "PL", name_it: "Polonia", flag: "🇵🇱" },
  { code: "PT", name_it: "Portogallo", flag: "🇵🇹" },
  { code: "PW", name_it: "Palau", flag: "🇵🇼" },
  { code: "PY", name_it: "Paraguay", flag: "🇵🇾" },
  { code: "QA", name_it: "Qatar", flag: "🇶🇦" },
  { code: "RO", name_it: "Romania", flag: "🇷🇴" },
  { code: "RS", name_it: "Serbia", flag: "🇷🇸" },
  { code: "RU", name_it: "Federazione Russa", flag: "🇷🇺" },
  { code: "RW", name_it: "Ruanda", flag: "🇷🇼" },
  { code: "SA", name_it: "Arabia Saudita", flag: "🇸🇦" },
  { code: "SB", name_it: "Isole Salomone", flag: "🇸🇧" },
  { code: "SC", name_it: "Seychelles", flag: "🇸🇨" },
  { code: "SD", name_it: "Sudan", flag: "🇸🇩" },
  { code: "SE", name_it: "Svezia", flag: "🇸🇪" },
  { code: "SG", name_it: "Singapore", flag: "🇸🇬" },
  { code: "SI", name_it: "Slovenia", flag: "🇸🇮" },
  { code: "SK", name_it: "Slovacchia", flag: "🇸🇰" },
  { code: "SL", name_it: "Sierra Leone", flag: "🇸🇱" },
  { code: "SM", name_it: "San Marino", flag: "🇸🇲" },
  { code: "SN", name_it: "Senegal", flag: "🇸🇳" },
  { code: "SO", name_it: "Somalia", flag: "🇸🇴" },
  { code: "SR", name_it: "Suriname", flag: "🇸🇷" },
  { code: "SS", name_it: "Sud Sudan", flag: "🇸🇸" },
  { code: "ST", name_it: "Sao Tomé e Principe", flag: "🇸🇹" },
  { code: "SV", name_it: "El Salvador", flag: "🇸🇻" },
  { code: "SY", name_it: "Siria", flag: "🇸🇾" },
  { code: "SZ", name_it: "Eswatini", flag: "🇸🇿" },
  { code: "TD", name_it: "Ciad", flag: "🇹🇩" },
  { code: "TG", name_it: "Togo", flag: "🇹🇬" },
  { code: "TH", name_it: "Thailandia", flag: "🇹🇭" },
  { code: "TJ", name_it: "Tagikistan", flag: "🇹🇯" },
  { code: "TL", name_it: "Timor Orientale", flag: "🇹🇱" },
  { code: "TM", name_it: "Turkmenistan", flag: "🇹🇲" },
  { code: "TN", name_it: "Tunisia", flag: "🇹🇳" },
  { code: "TO", name_it: "Tonga", flag: "🇹🇴" },
  { code: "TR", name_it: "Turchia", flag: "🇹🇷" },
  { code: "TT", name_it: "Trinidad e Tobago", flag: "🇹🇹" },
  { code: "TV", name_it: "Tuvalu", flag: "🇹🇻" },
  { code: "TZ", name_it: "Tanzania", flag: "🇹🇿" },
  { code: "UA", name_it: "Ucraina", flag: "🇺🇦" },
  { code: "UG", name_it: "Uganda", flag: "🇺🇬" },
  { code: "US", name_it: "Stati Uniti d'America", flag: "🇺🇸" },
  { code: "UY", name_it: "Uruguay", flag: "🇺🇾" },
  { code: "UZ", name_it: "Uzbekistan", flag: "🇺🇿" },
  { code: "VA", name_it: "Stato Citta' Del Vaticano", flag: "🇻🇦" },
  { code: "VC", name_it: "Saint Vincent e Grenadine", flag: "🇻🇨" },
  { code: "VE", name_it: "Venezuela", flag: "🇻🇪" },
  { code: "VN", name_it: "Vietnam", flag: "🇻🇳" },
  { code: "VU", name_it: "Vanuatu", flag: "🇻🇺" },
  { code: "WS", name_it: "Samoa", flag: "🇼🇸" },
  { code: "YE", name_it: "Yemen", flag: "🇾🇪" },
  { code: "ZA", name_it: "Sud Africa", flag: "🇿🇦" },
  { code: "ZM", name_it: "Zambia", flag: "🇿🇲" },
  { code: "ZW", name_it: "Zimbabwe", flag: "🇿🇼" },
];

/**
 * Look up a country by ISO alpha-2 code. Case-insensitive. Returns
 * `null` if not found (do NOT default to Italy — the caller decides).
 * @param {string} iso e.g. "BY"
 * @returns {{code:string,name_it:string,flag:string}|null}
 */
export const findCountryByIso = (iso) => {
  if (!iso) return null;
  const up = String(iso).trim().toUpperCase();
  return ALL_ISO_COUNTRIES.find((c) => c.code === up) || null;
};

export default ALL_ISO_COUNTRIES;
